/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const IbanInvoicePaymentStatusEnum = {
    Initialized: 'Initialized',
    Paid: 'Paid'
} as const;

export type IbanInvoicePaymentStatusEnum = typeof IbanInvoicePaymentStatusEnum[keyof typeof IbanInvoicePaymentStatusEnum];



